import type { Season, TEpisode } from '~/src/common/lean-back';

const EMPTY_EPISODES_LIST: TEpisode[] = [];
export function getSeasonEpisoded(season: Season | null): TEpisode[] {
  if (season === null) {
    return EMPTY_EPISODES_LIST;
  }
  return season.episodes;
}
